import { VisitOverviewIcon } from '@va/icons';
import { useLocale, useTranslate } from '@va/localization';
import { ListCardItemWithIcon, ParagraphWithTooltip, paragraphSizes } from '@va/ui/design-system';
import { formatMomentDuration, formatTime } from '@va/util/helpers';
import moment from 'moment';

export const SessionDetails = ({
  wrapperClassName,
  sessionDuration,
  sessionStartAt,
}: {
  wrapperClassName?: string;
  sessionDuration: number;
  sessionStartAt: number;
}) => {
  const translate = useTranslate();
  const { locale } = useLocale();
  const formattedTime = formatTime(formatMomentDuration(moment.duration(sessionDuration)));

  return (
    <ListCardItemWithIcon
      topText={
        sessionDuration
          ? translate('visitorHistory.sessionDuration', {
              length: formattedTime,
            })
          : translate('visitorsHistory.sessionDuration.notAccessible')
      }
      bottomNode={
        <ParagraphWithTooltip size={paragraphSizes.tiny} className='text-gray-devilSolid text-left gap-1.2'>
          {moment(sessionStartAt * 1000)
            .locale(locale)
            .format('lll')}
          {sessionDuration && (
            <>
              &nbsp;&rarr;&nbsp;
              {moment(sessionStartAt * 1000 + sessionDuration)
                .locale(locale)
                .format('hh:mm A')}
            </>
          )}
        </ParagraphWithTooltip>
      }
      icon={
        <div className='h-12 w-12 rounded-full bg-white-snow group-hover:bg-white flex items-center justify-center'>
          <VisitOverviewIcon color='#696969' />
        </div>
      }
      wrapperClassName={wrapperClassName}
    />
  );
};
